import { render } from "./LiquidationTimeline.vue?vue&type=template&id=b2ef2ad8"
import script from "./LiquidationTimeline.vue?vue&type=script&lang=js"
export * from "./LiquidationTimeline.vue?vue&type=script&lang=js"

import "./LiquidationTimeline.vue?vue&type=style&index=0&id=b2ef2ad8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__